<template>
    <div>
        <div
            id="main-wrapper"
            data-navbarbg="skin6"
            data-theme="light"
            data-layout="vertical"
            data-sidebartype="full"
            data-boxed-layout="full"
        >
            <Header-Partial></Header-Partial>
            <slot></slot>
        </div>
    </div>
</template>

<script>
import HeaderPartial from "@/views/Header";
export default {
    name: "DefaultLayout",
    components: {
        HeaderPartial,
    },
    data () {
        return {};
    },
    created () {
        localStorage.setItem("appIDactual", 0);
    },
};
</script>

<style></style>
